import {
  Component,
  Input,
  AfterViewInit,
  ViewChild,
  ComponentFactoryResolver,
  OnDestroy,
  ChangeDetectorRef,
  Renderer2
} from '@angular/core';
import { Inspection } from '../shared/models/index';
import { BaseInstallationPluginComponent } from './installation/base-installation/view.component';
import { PluginDirective } from './plugin.directive';

@Component({
    selector: 'ir-plugin',
    template: '<ng-template plugin></ng-template>',
    standalone: false
})
export class PluginComponent implements AfterViewInit, OnDestroy {
  static plugins: any = {};
  static initializers: any = {};
  static downloads: any = {};

  @Input()
  plugin: any;
  @Input()
  inspection: Inspection;
  @Input()
  showBreadcrumbs: boolean = false;
  @Input()
  showValidations: boolean = false;
  @Input()
  showContent: boolean = true;
  @Input()
  messages: Array<string> = [];
  @ViewChild(PluginDirective, { static: true })
  componentDirective: PluginDirective;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit() {
    this.loadComponents();
  }

  ngOnDestroy() {}

  getComponent(pluginType: string) {
    if (pluginType == null) {
      return null;
    }
    const res = PluginComponent.plugins[pluginType.toLowerCase()];

    if (res == null) {
      return null;
    }

    return res;
  }

  loadComponents() {
    if (this.plugin.pluginType.includes('installation')) {
      let pluginComponent = this.getComponent(this.plugin.pluginType);
      if (pluginComponent != null) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(BaseInstallationPluginComponent);
        const viewContainerRef = this.componentDirective.viewContainerRef;
        const cmp = viewContainerRef.createComponent(componentFactory);
        this.renderer.addClass(cmp.location.nativeElement, 'ir-installation-plugin');
        if (!cmp?.instance) return;
        (<any>cmp.instance).pluginName = this.plugin.pluginType;
        (<any>cmp.instance).pluginComponent = pluginComponent;
        (<any>cmp.instance).config(
          this.plugin,
          this.inspection,
          this.messages,
          this.showBreadcrumbs,
          this.showValidations,
          this.showContent
        );
      }
    } else {
      let pluginComponent = this.getComponent(this.plugin.pluginType);
      if (pluginComponent != null) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(pluginComponent);
        const viewContainerRef = this.componentDirective.viewContainerRef;
        const cmp = viewContainerRef.createComponent(componentFactory);
        (<any>cmp.instance).config(
          this.plugin,
          this.inspection,
          this.messages,
          this.showBreadcrumbs,
          this.showValidations,
          this.showContent
        );
      }
    }
    this.cdr.detectChanges();
  }
}
